import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '../../utils/cn';
import { Button } from '../button/button';
import { Inline } from '../inline/inline';

type DrawerNavigationProps = {
  navigationConfig: {
    isFirstInvoice: boolean;
    isLastInvoice: boolean;
    onPrevious: () => void;
    onNext: () => void;
  };
  className?: string;
  buttonClassName?: string;
};

export const DrawerNavigation = ({ navigationConfig, className, buttonClassName }: DrawerNavigationProps) => {
  return (
    <Inline space={0.5} className={cn('w-max rounded-full bg-muted px-2 py-1.5', className)}>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Navigate to previous"
        disabled={navigationConfig.isFirstInvoice}
        onClick={navigationConfig.onPrevious}
        className={cn('h-5 w-5', buttonClassName)}
      >
        <ChevronUp size={20} />
      </Button>

      <Button
        variant="ghost"
        size="icon"
        aria-label="Navigate to next"
        disabled={navigationConfig.isLastInvoice}
        onClick={navigationConfig.onNext}
        className={cn('h-5 w-5', buttonClassName)}
      >
        <ChevronDown size={20} />
      </Button>
    </Inline>
  );
};
